import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  children: Node;
  className?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  isIconButton?: boolean;
  onClick: () => void;
};
export const FilterButton = ({
  children,
  className,
  isActive = false,
  isDisabled = false,
  isIconButton,
  onClick,
  ...rest
}: Props) => (
  <button
    {...rest}
    className={classnames(
      'animation-duration-500 flex min-h-40 animate-fadeIn items-center justify-center gap-15 whitespace-nowrap border-1 border-solid text-14 font-bold transition-colors duration-250 ease-in',
      {
        'rounded-4 p-2 leading-0': isIconButton,
        'rounded-pill px-15 py-10 leading-1': !isIconButton,
        'bg-white hocus:border-black': !isActive && !isDisabled,
        'border-white': !isActive && !isDisabled && isIconButton,
        'border-grey': !isActive && !isDisabled && !isIconButton,
        'cursor-not-allowed border-grey bg-pearl text-grey': isDisabled,
        'border-saffron bg-saffron text-black': isActive && !isDisabled && !isIconButton,
        'border-saffron bg-white text-black': isActive && !isDisabled && isIconButton,
      },
      className,
    )}
    disabled={isDisabled}
    onClick={onClick}
    type="button"
  >
    {children}
    {!isDisabled && isActive && !isIconButton && (
      <Icon
        className="animation-duration-500 animate-fadeIn leading-0"
        name={ICONS.CHECK}
        width="0.75rem"
      />
    )}
  </button>
);
